import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: '',
  table: 'speed_limit',
  title: 'Ограничения скорости',
  apiType: apiTypes.REPORT_API,
  connections: {
    geo_zones: {
      apiType: apiTypes.REPORT_API,
      table: 'geo_zones',
      fields: [],
      autocomplete: false,
      format: (elem: any) => elem['geo_zone_name'],
      index: 'geo_zone_id',
      disableFilter: true,
      multipleSelection: true
    },
  },
  fields: [
    {
      name: 'speed_limit_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'name',
      title: 'Наименование',
      type: 'text',
      required: true,
      validate: (value: any) => /^[A-Za-z-А-Яа-я-0-9_-]+$/.test(value),
      validateError: 'Допустимы только буквы, цифры и знаки "_" и "-"',
      width: '16%',
      maxLengthValue: 255
    },
    {
      name: 'geo_zone_id',
      title: 'Геозона',
      type: 'text',
      id_type: 'number',
      connection: 'geo_zones',
      required: true,
      width: '16%',
      multipleSelection: true
    },
    {
      name: 'value',
      title: 'Вес (оценка) превышения',
      type: 'number',
      required: true,
      width: '16%',
    },
    {
      name: 'priority',
      title: 'Приоритет привышения',
      type: 'number',
      required: true,
      width: '16%',
    },
    {
      name: 'threshold',
      title: 'Попроговое значение (км/ч)',
      type: 'number',
      required: true,
      width: '16%',
    },
    {
      name: 'color',
      title: 'Цвет',
      type: 'color',
      required: true,
      width: '50px',
      disableFilter: true,
    }
  ],
  newTemplate: {
    speed_limit_id: null,
    name: null,
    geo_zone_id: null,
    value: null,
    priority: null,
    threshold: null,
    color: null,
  },
  createField: 'createdAt',
  updateField: 'updatedAt',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'speed_limit_id',
    direction: 'desc'
  },
  import: {
    header: [
      {
        title: 'speed_limit_id',
        field: 'speed_limit_id',
      },
      {
        title: 'name',
        field: 'name',
      },
      {
        title: 'geo_zone_id',
        field: 'geo_zone_id',
      },
      {
        title: 'value',
        field: 'value',
      },
      {
        title: 'priority',
        field: 'priority',
      },
      {
        title: 'threshold',
        field: 'threshold',
      },
      {
        title: 'color',
        field: 'color',
      }
    ],
    example: `1;Превышение60+20;1111;1;1;80;#ff0000`,
  },

};

export default config;
